import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';

import * as firebaseui from 'firebaseui';
import firebase from 'firebase/app'
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { AppState } from '../../state/state';
import { Store } from '@ngrx/store';
import { User } from '../user';
import { login } from '../auth.actions';

@Component({
   selector: 'app-login',
   templateUrl: './login.component.html',
   styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit, OnDestroy {

  ui: firebaseui.auth.AuthUI;
   constructor(
     private afAuth: AngularFireAuth, 
     private router: Router, 
     private ngZone: NgZone,
     private store: Store<AppState>
     ) {}

   ngOnInit(): void {
     
      const uiConfig = {
         signInOptions: [
           firebase.auth.GoogleAuthProvider.PROVIDER_ID,
           firebase.auth.EmailAuthProvider.PROVIDER_ID
        ],
        callbacks: {
          signInSuccessWithAuthResult: this.onLoginSuccessful.bind(this)
        }
      };
    
      // this.ui = new firebaseui.auth.AuthUI(this.afAuth.app);
      // this.ui.start('#firebaseui-auth-container', uiConfig);

      this.afAuth.app.then((app) => {
        this.ui = new firebaseui.auth.AuthUI(app.auth());
        this.ui.start('#firebaseui-auth-container', uiConfig);
      });
   }

   ngOnDestroy() {
     this.ui.delete();
   }

   onLoginSuccessful(result) {
    console.log("Firebase UI result:", result);
    const user: User = {
      name: result.user.displayName,
      email: result.user.email,
      photoUrl: result.user.photoURL
    };
    // console.log('User obj: ', user);

    const newLoginAction = login({user: user})
    this.store.dispatch(newLoginAction);

    this.ngZone.run(() => this.router.navigateByUrl('/dashboard'));
   }



  //  login() {
  //   this.afAuth.signInWithPopup(new firebase.auth.GoogleAuthProvider());
  // }
  // logout() {
  //   this.afAuth.signOut();

  // }
}
